const app = "ثبت سفارش سرنخ";
const _app = app + " | ";

export const webPagesTitle = {
  splash_screen: app,

  insert_mobile: _app + "ورود با شماره موبایل",
  verify_code: _app + "کد تایید",
  home_stack: app,
  home: app,
  profile: _app + "اطلاعات کاربری",
  company_profile: _app + "اطلاعات شرکت",
  contact_us: _app + "ارتباط با سرنخ",
  about_us: _app + "درباره سرنخ",
  factor: _app + "اطلاعات سفارش",
  factor_pdf: "خروجی فاکتور",
  factors: _app + "سفارسات و فاکتورها",
  category: _app + "گروه محصولات",
  products: _app + "محصولات",
  cart: _app + "سبد خرید",
  order_details: _app + "جزییات سفارش",
  orders: _app + "سفارشات",
};
